/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardOrderAddressResponseViewModel } from "../types/CreditCardOrderAddressResponseViewModel.ts";

export const creditCardOrderAddressResponseViewModelSchema = z.object({
  street: z.string().nullish(),
  placeNumber: z.string().nullish(),
  neighborhood: z.string().nullish(),
  complement: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  country: z.string().nullish(),
  zipCode: z.string().nullish(),
}) as unknown as ToZod<CreditCardOrderAddressResponseViewModel>;
